"use client";

import React from "react";
export default function TheTalent() {
  return <section id="latest-releases" className="relative text-foreground py-20 md:py-32 px-4 overflow-hidden" style={{
    background: `url("https://trusty-wren.10web.cloud/wp-content/uploads/2026/04/cropped-585938437_1404690281026844_6180650554395961031_n.jpg") center/cover no-repeat`
  }} aria-label="Latest Spotify Releases">
      {/* Dark overlay for contrast */}
      <div className="absolute inset-0 bg-black/70"></div>

      {/* Content wrapper */}
      <div className="relative max-w-6xl mx-auto z-10">
        {/* Section heading */}
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-8 text-center">
          Latest Releases
        </h2>

        {/* Responsive Spotify embed */}
        <div className="relative w-full md:w-[90%] mx-auto" style={{
        paddingTop: "56.25%"
      }}>
          <iframe data-testid="embed-iframe" title="Spotify Album: Latest Releases" className="absolute top-0 left-0 w-full h-full rounded-xl shadow-lg" src="https://open.spotify.com/embed/album/2LLLEEvxtLMv4YMnPzTjEX?utm_source=generator" frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" />
        </div>
      </div>
    </section>;
}